
import { PaymentMethod } from '@stripe/stripe-js'
import CSSStyle from './StripePaymentButton/index.module.css';
import React, { useCallback, useState, PropsWithChildren, Context } from 'react'
// import { isSafari } from './utils/utils'
import { useEffect } from 'react'
import { useStripe } from '@stripe/react-stripe-js'
import { BrowserPaymentRequestInitialization, CardPaymentMethodInfo, ChowbusStripePaymentContextData, PaymentRequestInfo, PaymentType } from './model';
import StripeCreditCardEntry from './StripeCreditCardEntry'
import { JoinClassName } from './utils/cssHelper'
import Logger from './utils/consolelog';

const LOGPRIX = "==ChowbusStripePaymentProvider==";
export const ChowbusStripePaymentContext: Context<ChowbusStripePaymentContextData> =
  React.createContext<ChowbusStripePaymentContextData>({
    browserPaymentRequestInitialized: null,
    paymentRequestInfo: null,
    cardPaymentMethodInfo: null,
    onCreditCardMethodRequest: null,
    showPaymentDoing: () => { },
    closePaymentDoing: () => { },
    onCancelCreditCardMethodRequest: null,
  })

export type ChowbusStripePaymentProviderProviderProps = PropsWithChildren<{
  paymentRequestInfo: PaymentRequestInfo;
}>;

function retrieveCardPaymenMethodInfo(paymentMethod: PaymentMethod, paymentType: PaymentType): CardPaymentMethodInfo {
  let { id, card, customer, metadata } = paymentMethod;
  return {
    paymentMethodId: id,
    card: card as PaymentMethod.Card,
    customer,
    metadata,
    paymentType,
  }
}


export default function ChowbusStripePaymentProvider(props: ChowbusStripePaymentProviderProviderProps) {
  let { paymentRequestInfo } = props;
  const stripe = useStripe();
  let [paymentTargetOrderId, setPaymentTargetOrderId] = useState<string>(
    paymentRequestInfo.orderId
  )
  let [paymentRequestInitialized, setPaymentRequestInitialized] = useState<BrowserPaymentRequestInitialization | null>(null)
  let [showCreditCardEntry, setShowCreditCardEntry] = useState<boolean>(false);
  let [cardPaymentMethodInfo, setCardPaymentMethodInfo] = useState<CardPaymentMethodInfo | null>(null);
  let [showLoading, setShowLoading] = useState<boolean>(false);

  useEffect(() => {
    setPaymentTargetOrderId(paymentRequestInfo.orderId)
  }, [paymentRequestInfo])

  useEffect(() => {
    setPaymentRequestInitialized(null);
    setCardPaymentMethodInfo(null);
  }, [paymentTargetOrderId])



  let preparePaymentRequest = useCallback(async () => {
    if (stripe && !paymentRequestInitialized) {
      //support Apple pay or google Play
      let applePayIsSupport = false
      let googlePayIsSupport = false
      let obj = Object.assign({
        country: 'US',
        currency: 'usd',
        total: {
          amount: 100,
          label: 'Total'
        }
      })
      try {
        let pr = stripe.paymentRequest(obj)
        // Check the availability of the Payment Request API.
        let canMakePaymentResult = await pr.canMakePayment()
        if (canMakePaymentResult && process.env.REACT_APP_TEST_APPLE_PAY_WITH_GOOGLE_PAY === '1') {
          applePayIsSupport = true;
          googlePayIsSupport = false;
        } else {
          if (canMakePaymentResult) {
            let { applePay, googlePay } = canMakePaymentResult;
            applePayIsSupport = !!applePay;
            googlePayIsSupport = !!googlePay;
          } else {
            applePayIsSupport = false
            googlePayIsSupport = false
          }

        }

        setPaymentRequestInitialized({
          applePayIsSupport,
          googlePayIsSupport,
          paymentRequest: ((applePayIsSupport || googlePayIsSupport) && pr) || null,
        })
      } catch (error) {
        console.error(error)
        setPaymentRequestInitialized({
          applePayIsSupport,
          googlePayIsSupport,
          paymentRequest: null
        })
      }
    }
  }, [paymentRequestInitialized, stripe])

  useEffect(() => {
    preparePaymentRequest()
  }, [preparePaymentRequest])

  let showPaymentDoing = useCallback(() => {
    Logger(LOGPRIX, 'showPaymentDoing');
    setShowLoading(true);
  }, []);

  let closePaymentDoing = useCallback(() => {
    Logger(LOGPRIX, 'closePaymentDoing');
    setShowLoading(false);
  }, []);


  let onCreditCardMethodRequest = useCallback(() => {
    setShowCreditCardEntry(true);
  }, []);

  let onCancelCreditCardMethodRequest = useCallback(() => {
    setShowCreditCardEntry(false);
    setCardPaymentMethodInfo(null);
  }, []);

  let onCancelNewCreditCard = useCallback(() => {
    setShowCreditCardEntry(false);
  }, []);


  let onCreditCardReady = useCallback(async (paymentMethod: PaymentMethod) => {
    //try to create pyament method
    setShowCreditCardEntry(false);
    setCardPaymentMethodInfo(retrieveCardPaymenMethodInfo(paymentMethod as PaymentMethod, PaymentType.BankCard_CreditCard));
    //show credit card payment interface
  }, []);

  return (
    <React.Fragment>
      <ChowbusStripePaymentContext.Provider value={{
        browserPaymentRequestInitialized: paymentRequestInitialized,
        paymentRequestInfo: paymentRequestInfo,
        cardPaymentMethodInfo: cardPaymentMethodInfo,
        onCreditCardMethodRequest: onCreditCardMethodRequest,
        onCancelCreditCardMethodRequest: onCancelCreditCardMethodRequest,
        showPaymentDoing: showPaymentDoing,
        closePaymentDoing: closePaymentDoing,
      }}>
        {props.children}
        {
          showCreditCardEntry && <StripeCreditCardEntry
            shown={true}
            onCreditCardReady={onCreditCardReady}
            paymentRequestInfo={paymentRequestInfo}
            onShowLoading={showPaymentDoing}
            onCloseLoading={closePaymentDoing}
            onCancelNewCreditCard={onCancelNewCreditCard}></StripeCreditCardEntry>
        }
        {
          showLoading && (<div className={JoinClassName(CSSStyle.overall_loading_layer)}>
            <div className={CSSStyle.loading_container}>
              <div className={CSSStyle.loading_icon}></div>
            </div>
          </div>)
        }
      </ChowbusStripePaymentContext.Provider>
    </React.Fragment >
  );
}